import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../Card';
interface MetricCardProps {
  label: string;
  value: string;
  hint: string;
}
export function MetricCard({
  label,
  value,
  hint
}: MetricCardProps) {
  return <Card size="sm" data-id="element-197" data-mp="3nditeo6stvmw">
      <CardHeader data-id="element-198" data-mp="3nf2a2fwda8p7">
        <CardDescription className="font-mono text-xs uppercase tracking-[0.14em]" data-id="element-199" data-mp="3jbxdetyyx18h">
          {label}
        </CardDescription>
        <CardTitle className="font-mono text-2xl tabular-nums" data-id="element-200" data-mp="jvh574h0y8ak">{value}</CardTitle>
      </CardHeader>
      <CardContent data-id="element-201" data-mp="eyh1h07ndhmm">
        <p className="text-xs text-muted-foreground" data-id="element-202" data-mp="ey7j9ysugerh">{hint}</p>
      </CardContent>
    </Card>;
}